export const positionMap = {
    "absolute": "cui-absolute",
    "relative": "cui-relative",
    "fixed": "cui-fixed",
    "static": "cui-static",
    "sticky": "cui-sticky"
}